export default __webpack_public_path__ + "static/media/(1)-DTW2019-Data-Teaching-Workshop-September-2019,-San-Diego.a35016f1.md";